module.exports = "pegasus/assets/theme5/medium/5.jpg";